function courses(
  state = { items: [], selectedId: 0, selectedCourse: null },
  action
) {
  switch (action.type) {
    case 'RECEIVE_COURSES':
      return {
        ...state,
        items: action.courses,
      };
    case 'SELECT_COURSE':
      return {
        ...state,
        selectedId: action.id,
      };
    case 'RECEIVE_COURSE':
      localStorage.setItem('lastPlatform', action.course.type);
      return {
        ...state,
        selectedCourse: action.course,
      };
    case 'RECEIVE_COMPLETITION':
      return {
        ...state,
        selectedCourse: {
          ...state.selectedCourse,
          completition: action.completition,
        },
      };
    case 'UNSELECT_COURSE':
      return {
        ...state,
        selectedCourse: null,
      };
    default:
      return state;
  }
}

export default courses;
